module.exports = __webpack_public_path__ + "static/media/superheroe.105a2763.svg";